import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "alternatives-comparison" }
const _hoisted_2 = { class: "table-wrapper" }
const _hoisted_3 = { class: "criteria-header" }
const _hoisted_4 = { class: "criterion-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_table, { class: "heatmap-table" }, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.rowLabel), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternatives, (alt) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: alt.id,
                  class: "alternative-header"
                }, _toDisplayString(alt.name), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row.id
              }, [
                _createElementVNode("td", _hoisted_4, _toDisplayString(row.name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternatives, (alt) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: alt.id,
                    class: "attitude-cell",
                    style: _normalizeStyle({ backgroundColor: _ctx.getCellColor(_ctx.getAttitude(row.id, alt.id)) })
                  }, _toDisplayString(_ctx.getAttitude(row.id, alt.id).toFixed(2)), 5))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}